import FormAgentes from "../componentes/FormAgentes.vue";
import ListaAgentes from "../componentes/ListaAgentes.vue";
import ListaObjetivo from "../componentes/ListaObjetivo.vue";
import ComisionesAgente from "../componentes/ComisionesAgente.vue";

const routes = [
    ...route("/guardar-agente", FormAgentes, {
        Auth: true,
        ///req_admin: true
    }),
    ...route("/lista-agentes", ListaAgentes, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/comisiones-agentes", ComisionesAgente, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/lista-objetivo-ventas", ListaObjetivo, {
        Auth: true,
        //req_admin: true
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
